/* global BigInt */
import axios from "axios";

const BSC_RPC_URL =
  "https://rpc.ankr.com/bsc/7445d75ddb7cb62fa848a6b22b6ea12f316e8c07308248256c70c02e95e74330";

// ERC-20 selectors: name(), symbol(), decimals(), totalSupply()
const SELECTORS = {
  name: "0x06fdde03",
  symbol: "0x95d89b41",
  decimals: "0x313ce567",
  totalSupply: "0x18160ddd",
};

const decodeString = (hex) => {
  if (!hex || hex === "0x") return "";
  const data = hex.slice(2);
  // ABI-encoded dynamic string: offset (32B) | length (32B) | bytes
  const len = parseInt(data.slice(64, 128), 16);
  const bytes = data.slice(128, 128 + len * 2).match(/.{2}/g) || [];
  return new TextDecoder().decode(
    new Uint8Array(bytes.map((b) => parseInt(b, 16))),
  );
};

// Reads name, symbol, decimals and total supply of a BEP-20 token via the
// Ankr BSC RPC. Resolves to null if the call fails.
export const fetchBep20Info = async (address) => {
  try {
    const keys = Object.keys(SELECTORS);
    const res = await axios.post(
      BSC_RPC_URL,
      keys.map((key, id) => ({
        jsonrpc: "2.0",
        id,
        method: "eth_call",
        params: [{ to: address, data: SELECTORS[key] }, "latest"],
      })),
    );
    const out = {};
    res.data.forEach((r) => {
      out[keys[r.id]] = r.result;
    });
    const decimals = parseInt(out.decimals, 16);
    return {
      name: decodeString(out.name),
      symbol: decodeString(out.symbol),
      decimals,
      totalSupply: Number(BigInt(out.totalSupply)) / 10 ** decimals,
    };
  } catch (error) {
    console.error("Error fetching on-chain token info:", error);
    return null;
  }
};
